var _style, _g, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoTestagencyb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 159 41",
    style: {
      enableBackground: "new 0 0 159 41"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{font-family:'MyriadPro-Regular';}\n\t.st2{font-size:19px;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layout-Desktop-Invision"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_00-Sign-In",
    transform: "translate(-137.000000, -28.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Freede_Logo_new",
    transform: "translate(137.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "st0",
    d: "M20.5,24.9c-0.3-0.3-0.8,0.1-0.5,0.4c2.5,3,5.3,6,8.9,7.9c1.7,1,3.7,1.5,5.7,1.3 c2.2-0.2,3.9-1.6,5.1-3.3c2.3-3.2,1.2-7.5-1.4-10.1c0.9-0.3,1.6-0.8,2.3-1.4c1.2-1,1.6-2.4,1.5-3.9c-0.2-2.6-2.6-5.2-5.3-5.4 c-0.2,0-0.3,0.3-0.1,0.3c2.2,0.6,3.8,2.7,3.8,5c0,1.1-0.4,2-1.2,2.7s-1.9,1.2-2.9,1.5c-0.7,0.2-1,1.1-0.4,1.5 c1.8,1.2,3,3.3,3.2,5.5c0.1,2.1-1.2,4.2-2.9,5.2c-3.4,2.1-7.6-0.6-10.3-2.6C24.1,28.2,22.3,26.6,20.5,24.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1_",
    className: "st0",
    d: "M31.5,35.1c0-0.2-0.3-0.3-0.3-0.1c-0.7,2.1-2.8,3.7-5.1,3.8c-1.1,0-2.1-0.4-2.8-1.2 c-0.8-0.8-1.2-1.9-1.5-2.9c-0.2-0.7-1.1-1-1.6-0.3c-1.3,1.8-3.4,2.9-5.6,3.1c-2.1,0.2-4.3-1.1-5.3-2.9 c-2.1-3.4,0.6-7.4,2.7-10.1c1.5-1.9,3.1-3.7,4.8-5.4c0.3-0.3-0.1-0.7-0.4-0.5c-3.1,2.5-6.2,5.3-8.1,8.7c-1,1.7-1.5,3.6-1.3,5.6 c0.2,2.1,1.7,3.8,3.4,5c3.2,2.2,7.6,1.1,10.3-1.4c0.3,0.8,0.8,1.6,1.4,2.3c1.1,1.1,2.5,1.6,4,1.5C28.7,40.1,31.3,37.8,31.5,35.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2_",
    className: "st0",
    d: "M6.4,29.5c-2.2-0.6-3.8-2.7-3.8-5c0-1.1,0.4-2,1.2-2.8c0.8-0.7,1.9-1.2,2.9-1.4 c0.7-0.2,1-1.1,0.3-1.5c-1.8-1.2-3-3.4-3.2-5.5c-0.1-2.1,1.2-4.2,3-5.2c3.4-2.1,7.6,0.6,10.3,2.6c2,1.5,3.8,3.1,5.6,4.7 c0.3,0.3,0.8-0.1,0.5-0.4c-2.5-3-5.3-6-8.9-7.9c-1.7-0.9-3.7-1.5-5.7-1.3C6.4,6,4.7,7.4,3.5,9.1c-2.3,3.1-1.2,7.5,1.4,10.1 C4,19.5,3.3,20,2.6,20.6c-1.2,1-1.6,2.4-1.5,3.9c0.2,2.6,2.6,5.2,5.3,5.4C6.5,29.9,6.6,29.6,6.4,29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3_",
    className: "st0",
    d: "M11.7,5.2c0,0.2,0.3,0.3,0.3,0.1c0.7-2.1,2.8-3.7,5.1-3.7c1.1,0,2.1,0.4,2.9,1.2 c0.7,0.8,1.2,1.9,1.5,2.9c0.2,0.7,1.1,1,1.6,0.3c1.3-1.8,3.4-2.9,5.6-3.1C30.8,2.7,32.9,4,34,5.7c2.1,3.4-0.6,7.5-2.7,10.1 c-1.5,1.9-3.1,3.7-4.8,5.5c-0.3,0.3,0.1,0.7,0.4,0.5c3.1-2.5,6.2-5.2,8.1-8.7c1-1.7,1.5-3.7,1.3-5.6c-0.2-2.1-1.7-3.8-3.4-5 c-3.2-2.2-7.6-1.1-10.3,1.4c-0.3-0.8-0.8-1.6-1.4-2.3c-1.1-1.1-2.5-1.6-4-1.5C14.5,0.2,11.8,2.5,11.7,5.2z"
  })))))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 49.104 27.501)",
    className: "st0 st1 st2"
  }, "Test AgencyB")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTestagencyb);
export default __webpack_public_path__ + "static/media/logo-testagencyb.8ecde0678f905b35fb058aa8db64052b.svg";
export { ForwardRef as ReactComponent };